export default {
  title_developers: 'Tüm geliştiriciler',
  breadcrumbs: {
    home: 'Ana sayfa',
    developers: 'Geliştiriciler'
  },
  logo_alt: 'Geliştirici logosu',
  banner_alt: 'Geliştirici afişi',
  gallery_image_alt: 'Galeri resmi',
  founded: 'Kuruluş yılı',
  residential_complexes: 'Konut kompleksleri',
  buildings: 'Binalar',
  properties: 'Mülkler',
  no_available: 'Mevcut geliştirici yok',
  gallery: 'Fotoğraf galerisi',
  video: 'Video',
  contacts: 'İletişim',
  residential_complexes_from: '{name} konut kompleksleri',
  properties_from: '{name} mülkleri',
  tabs: {
    base: 'Genel',
    media: 'Medya'
  },
  fields: {
    name: 'Adı',
    founded_year: 'Kuruluş yılı',
    website: 'Web sitesi',
    email: 'E-posta',
    phone: 'Telefon',
    country: 'Ülke',
    description_html: 'Açıklama (HTML)',
    project_types: 'Proje türleri',
    locations: 'Konumlar'
  },
  buttons: {
    more: 'Daha fazla',
    pagination: {
      prev: 'Geri',
      next: 'İleri'
    }
  }
}
